
import { CheckCircle } from "lucide-react";

export const AdvertiseBenefits = () => {
  const benefits = [
    "Trusted by local homeowners in OKC",
    "Affordable and targeted marketing options",
    "Reach customers actively searching for services",
    "Connect with qualified leads in your service area",
    "Build your brand's local presence"
  ];

  return (
    <div className="py-16 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-primary mb-8">Why Advertise With Us?</h2>
          
          <div className="grid md:grid-cols-2 gap-6 text-left">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="flex items-start space-x-3 p-4 rounded-lg bg-white shadow-sm"
              >
                <CheckCircle className="h-6 w-6 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-lg">{benefit}</span>
              </div>
            ))}
          </div>
          
          <div className="mt-8 p-6 bg-primary/10 rounded-lg">
            <p className="text-lg font-medium">
              Put your business in front of homeowners actively searching for services like yours
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
